import { call, put, takeEvery } from "redux-saga/effects"

import { GET_SETTINGS, UPDATE_SETTINGS } from "./actionTypes"
import {

  getSettingsFail,
  getSettingsSuccess,
  updateSettingsFail,
  updateSettingsSuccess,
} from "./actions"

import { get, post } from "helpers/api_helper"
import { Notification } from "../../components/Common/Notification"

function getSettingsAPi() {
  return get(
    `/settings/admin/all`
  )
}

const updateSettingsApi = ({ settings, settingsId }) => {
  return post(`/settings/admin/${settingsId}`, settings)
}

function* fetchSettings({ payload }) {
  try {
    const response = yield call(getSettingsAPi, payload)
    yield put(getSettingsSuccess(response))
  } catch (error) {
    yield put(getSettingsFail(error))
  }
}

function* onUpdateSettings({ payload }) {
  try {
    const response = yield call(updateSettingsApi, payload)
    if (response) {
      Notification({
        type: "success",
        message: "Settings Updated Successfully!",
        title: "",
      })

      yield put(updateSettingsSuccess(response))

      // ✅ close modal after success
      if (payload.handleCloseModal) {
        payload.handleCloseModal()
      }
    }
  } catch (error) {
    if (error.response?.data?.message) {
      Notification({
        type: "error",
        message: error.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(updateSettingsFail(error.response.data))
  }
}


function* settingsSaga() {
  yield takeEvery(GET_SETTINGS, fetchSettings)

  yield takeEvery(UPDATE_SETTINGS, onUpdateSettings)
}

export default settingsSaga

function doneNotification(message) {
  Notification({
    type: "success",
    message: message,
    title: "",
  })
}
